import {
    mapMutations
  } from 'vuex'
export const API_MIXINS = {
    methods: {
        ...mapMutations([
            'setMonthDailySales',
            'setCredits',
            'setAlert',
            'setAlertColor', 
            'setAlertText', 
            'setLoggedIn', 
            'setTodaysTransactions', 
            'setMonthSales',
            'setSupplies',
            'setTodaysFishcars',
            'setQuedTransactions',
            'setSequence',
            'setFishcarDailySales',
            'setIncomeSourceSummary',
            'setSalesSummary'
        ]),
      
        CHECKPERMISSION(action){
            if(!this.$session.get('permission')) {
                return true
            }
            var permissions = JSON.parse(this.$session.get('permission'))
            if(permissions.length == 0) { return true}
            for(var i = 0; i < permissions.length; i++) {
                if(permissions[i] == action) {
                    return true;
                }
            }
            return false 

        },
        IS_ADMIN(){
            if(this.$session.get('role') == 'administrator'){
              return true
            } return false
          },
        GET_TRANSACTIONS(param) {
            this.$http.post("sale/getitems", JSON.stringify(param)).then(response => {
                response.data.data != null ? this.setTodaysTransactions(response.data.data): this.setTodaysTransactions([])
                response.data.data != null ? this.setQuedTransactions(response.data.data): this.setQuedTransactions([])
                //this.SET_TODAYS_FISHCARS(response.data.data)
               }).catch(e => {
                console.log(e.data)
              })
        },
        GET_MONTHSALES() { 
            this.$http.post("summary/custom_query", JSON.stringify({method: "total_sales_this_month", param1: this.$moment().format("YYYY-MM")})).then(response => {
                response.data.data != null?this.setMonthSales(response.data.data):this.setMonthSales({})
            }).catch(e => {
            console.log(e.data)
            })
        },
        GET_CREDITS() { 
            this.$http.post("summary/credit_payments", {}).then(response => {
                response.data != null?this.setCredits(response.data):this.setCredits({})
            }).catch(e => {
            console.log(e.data)
            })
        
        },
        GET_MONTHDAILYSALES() { 
            this.$http.post("summary/custom_query", JSON.stringify({method: "total_daily_sales", param1: this.$moment().format("YYYY-MM")})).then(response => {
            response.data.data != null?this.setMonthDailySales(response.data.data):this.setMonthDailySales([])
            }).catch(e => {
            console.log(e.data)
            })
        },
        GET_SUPPLIES(start, end) {
            this.$http.post("product/query_by_date", JSON.stringify({startdate:start, enddate: end})).then(response => {
                response.data.data != null?this.setSupplies(response.data.data):this.setSupplies([])
            }).catch(e => {
            console.log(e.data)
            })
        },
        GET_TODAYS_FISHCARS(param) {
            this.$http.post("supplier/get_by_date",param).then(response => {
                response.data.data != null ? this.setTodaysFishcars(response.data.data): this.setTodaysFishcars([])
                //this.SET_TODAYS_FISHCARS(response.data.data)
               }).catch(e => {
                console.log(e.data)
              })
        },
        GET_SEQUENCE(fishcar) {
            this.$http.post("sale/get_sequence", JSON.stringify({id: fishcar})).then(response => {
                    response.data.data != null?this.setSequence(response.data.data.length + 1):this.setSequence(1)
             }).catch(e => {
              console.log(e.data)
            })
       },
       GET_FISHCAR_SALES(date, fishcar){
        this.$http.post("sale/query", JSON.stringify({param1: date, param2: fishcar.toString()})).then(response => {
            response.data.data != null?this.setFishcarDailySales(response.data.data):this.setFishcarDailySales([])
          }).catch(e => {
           console.log(e.data)
         })
       },
       GET_INCOME_SOURCE_SUMMARY(supplier){
           console.log("GET_INCOME_SOURCE_SUMMARY: ", supplier)
        this.$http.post("reports/income_source", {id: supplier}).then(response => {
            response.data.data != null?this.setIncomeSourceSummary(response.data.data):this.setIncomeSourceSummary([])
            }).catch(e => {
            console.log(e.data)
            })
       },
       GET_SALES_SUMMARY(supplier){
        this.$http.post("reports/sales_summary", {id: supplier}).then(response => {
            response.data.data != null?this.setSalesSummary(response.data.data):this.setSalesSummary([])
            }).catch(e => {
            console.log(e.data)
            })
       },
       SAVE_SALES(sales){
            this.$http.post("sale/update", sales).then(response => {
            if(response.data.status == true) {
                this.VA_ALERT('success', response.data.message)
            } else {
                this.VA_ALERT('error', response.data.message)
            }
            }).catch(e => {
            console.log(e)
            })
        },
        ADD_SALES(sales){
               // this.GET_SEQUENCE(sales.supplier)
            //setTimeout(()=>{
                    sales.sequence = this.$IsNum(this.SEQUENCE)
                    this.$http.post("sale/new", sales).then(response => {
                        if(response.data.status == true) {
                            this.setSequence(response.data.next_sequence)
                            this.VA_ALERT('success', response.data.message)
                        } else {
                            this.VA_ALERT('success', response.data.message)
                        }
                    }).catch(e => {
                    console.log(e)
                    })
           // }, 200)
        },
        VA_ALERT(color, message) {
                this.setAlertText(message)
                this.setAlertColor(color)
                this.setAlert(true)
        }
    } ///eof methods
}